import React from 'react';
import CopyIcon from '../Icons/CopyIcon';

const DCopyBtn = ({ children }) => {
  return (
    <div className="flex flex-col justify-start items-center gap-2 text-right text-xs text-inherit">
      {/* <div className='w-full flex items-center justify-end'>
        <button onClick={() => navigator.clipboard.writeText(children)} className='flex items-center gap-2'>
          <span className=''>Copy</span>
          <div className='w-4 h-4 flex items-center justify-center'>
            <CopyIcon />
          </div>
        </button>
      </div> */}
      {children}
    </div>
  );
};

export default DCopyBtn;
